var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"linkedin-btn",on:{"click":_vm.handleClickLinkinLogin}},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('span',[_vm._v("Sign in with LinkedIn")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }